import { useState, useEffect } from 'react';
import { collection, query, where, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';

export const useWorkspaces = (user) => {
    const [workspaces, setWorkspaces] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (!user) {
            setIsLoading(false);
            return;
        }

        setIsLoading(true);

        const workspacesQuery = query(
            collection(db, 'workspaces'),
            where(`members.${user.uid}`, '!=', null)
        );

        const unsubscribe = onSnapshot(workspacesQuery, (snapshot) => {
            const workspacesData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setWorkspaces(workspacesData);
            setIsLoading(false);
        }, (error) => {
            console.error("Error fetching workspaces:", error);
            setIsLoading(false);
        });

        return () => unsubscribe();
    }, [user]);

    return { workspaces, isLoading };
};
